// extracted by mini-css-extract-plugin
export var active = "_1z-7";
export var backButton = "_1z-6";
export var clone = "_1z-c";
export var collapseBar = "_1z-g";
export var collapseMode = "_1z-i";
export var dragHandle = "_1z-a";
export var dropdownIcon = "_1z-e";
export var hidden = "_1z-o";
export var iconContainer = "_1z-l";
export var iconSwapper = "_1z-n";
export var navItem = "_1z-4";
export var navItemIcon = "_1z-d";
export var navProfile = "_1z-5";
export var notificationDot = "_1z-m";
export var optionsContainer = "_1z-f";
export var primaryNav = "_1z-0";
export var primaryTab = "_1z-j";
export var secondaryNav = "_1z-1";
export var selected = "_1z-k";
export var settingsNav = "_1z-2";
export var settingsNavItems = "_1z-3";
export var show = "_1z-b";
export var sideNav = "_1z-h";
export var teamItem = "_1z-8";
export var userProfileItem = "_1z-9";